export default {"src":"/_next/static/media/zepto.b408ecf0.svg","height":30,"width":90,"blurWidth":0,"blurHeight":0};